import { useState } from 'react';

import {
  Container,
  ErrorLogsFilters,
  ErrorLogsTable,
  Show,
} from '../../components';
import { usePageTitle } from '../../hooks';
import { UserPermission } from '../../enums';
import { getPageTitle } from '../../utils/pages';
import { RequirePermission } from '../../security';
import { Nullable, ErrorLogsFilters as Filters } from '../../types';
import Reports from './partials/Reports';

const ErrorLogs = () => {
  usePageTitle(getPageTitle('reports.errorLogs'));
  const [filters, setFilters] = useState<Nullable<Filters>>(null);

  const handleSearch = (filters: Nullable<Filters>) => {
    setFilters(filters);
  };

  return (
    <RequirePermission oneOf={[UserPermission.ViewLogs]}>
      <Reports>
        <ErrorLogsFilters onSearch={handleSearch} />
        <Container>
          <Show if={!!filters}>
            <ErrorLogsTable filters={filters} />
          </Show>
        </Container>
      </Reports>
    </RequirePermission>
  );
};

export default ErrorLogs;
